
/**
 * Stream configuration presets for Gamma video player.
 *
 * Each configuration includes:
 * - bentoUrl: Primary source for video data (preferred)
 * - fallbackVideoData: Complete VideoData structure for fallback
 */

/**
 * Helper function to create complete fallback VideoData structure
 * @param {string} id - Unique identifier for the video
 * @param {string} headline - Primary headline text
 * @param {string} description - Primary description text
 * @param {string} publisher - Publisher name
 * @returns {object} Complete VideoData structure for fallback usage
 */
const createFallbackVideoData = (id, headline, description, publisher) => ({
  id: `${id}-fallback`,
  headline: { primary: headline },
  description: { primary: description },
  publisher: { name: publisher },
  primaryImage: {
    id: '',
    headline: { primary: '' },
    caption: '',
    altText: headline,
    url: { primary: '', slug: '', short: '' },
    encodingFormat: '',
    height: 0,
    width: 0,
    authors: [],
    source: { name: publisher },
    graphicContent: false,
  },
  duration: 0,
  videoAssets: [],
  mpxMetadata: {
    guid: `${id}-fallback-guid`,
    mpxId: `${id}-fallback-mpx`,
  },
  url: {
    primary: '',
    slug: '',
    short: '',
  },
  playable: true,
});

export const gammaStreamConfigPresets = {
  DATELINE: {
    bentoUrl: 'https://uat-ramen2.dev.nbcnews.com/bentoapi/video/mmvo245801029595',
    fallbackVideoData: createFallbackVideoData('dateline', 'Dateline', 'Dateline 247', 'NBC News'),
  },
  NBC_SPORTS: {
    bentoUrl: 'https://uat-ramen2.dev.nbcnews.com/bentoapi/video/mmvo245802053659',
    fallbackVideoData: createFallbackVideoData('nbc-sports', 'NBC Sports NOW', 'Live streaming coverage from NBC Sports NOW', 'NBC Sports'),
  },
  NEWS_NOW: {
    bentoUrl: 'https://uat-ramen2.dev.nbcnews.com/bentoapi/video/mmvo245798469773',
    fallbackVideoData: createFallbackVideoData('news-now', 'NBC News Now', 'Live streaming news coverage from NBC News Now', 'NBC News'),
  },
  NOTICIAS_AHORA: {
    bentoUrl: 'https://uat-ramen2.dev.nbcnews.com/bentoapi/video/mmvo245802053823',
    fallbackVideoData: createFallbackVideoData('noticias-ahora', 'Noticias Telemundo AHORA', 'Las últimas noticias y las historias más importantes para la comunidad latina.', 'NBC News'),
  },
  SKY_NEWS: {
    bentoUrl: 'https://uat-ramen2.dev.nbcnews.com/bentoapi/video/mmvo245801541709',
    fallbackVideoData: createFallbackVideoData('sky-news', 'Sky News', 'Sky News Live', 'Sky News'),
  },
  TELEMUNDO_DEPORTES_AHORA: {
    bentoUrl: 'https://uat-ramen2.dev.nbcnews.com/bentoapi/video/mmvo246165573534',
    fallbackVideoData: createFallbackVideoData('telemundo-deportes', 'Telemundo Deportes AHORA', 'Telemundo Deportes AHORA Live', 'Telemundo'),
  },
  TODAY_ALL_DAY: {
    bentoUrl: 'https://uat-ramen2.dev.nbcnews.com/bentoapi/video/mmvo245800517553',
    fallbackVideoData: createFallbackVideoData('today-all-day', 'TODAY All Day', 'TODAY All Day is a 24/7 streaming channel from NBC News where viewers can find everything they love about TODAY.', 'Today'),
  },
};
